<div class="d-flex flex-column text-center">
    @if (content.children?.connectcardlogo?.image; as image) {
        <img [src]="image.src" [alt]="image.alt" [width]="image.width" [height]="image.height" class="mx-auto d-block" />
    }
    @if (content.messages?.ConnectCardPageText && loginConfig.connectCardVersion === 2) {
        <div class="mt-3 mb-2" [vnDynamicHtml]="content.messages?.ConnectCardPageText"></div>
    }
</div>
<form [formGroup]="formGroup" novalidate class="mt-half form-base floating-form ten-top connect-card-form">
    <fieldset>
        <section>
            <lh-form-field
                [showSuccessValidation]="v2"
                [labelText]="content.form.connectcardnumber?.label || ''"
                [floatedLabelText]="content.form.connectcardnumber?.watermark || ''"
                [validationMessages]="content.form.connectcardnumber?.validation"
                [elementClass]="'form-group-label-i-l'">
                <input
                    [type]="deviceService.isiOS ? 'text' : 'tel'"
                    name="connectCardNumber"
                    lhNumberOnly
                    autocomplete="cc-number"
                    pattern="[0-9]*"
                    formControlName="connectCardNumber"
                    inputmode="numeric"
                    (blur)="connectCardBlur()"
                    class="form-control form-control-i-l form-group-i-l"
                    vnTrackingEvent="Event.Functionality.Login"
                    [vnTrackingData]="{
                        'page.referringAction': 'Login_ConnectCard_ConectCardNumber_Typed',
                        'page.siteSection': 'Authentication',
                    }"
                    [vnTrackingTrigger]="['change']"
                    (keydown.enter)="login($event)" />
                <vn-icon name="theme-account" extraClass="ui-icon vn-login__icon-left" />
            </lh-form-field>
            <lh-form-field
                [showSuccessValidation]="v2"
                [labelText]="content.form.pin?.label || ''"
                [floatedLabelText]="content.form.pin?.watermark || ''"
                [validationMessages]="content.form.pin?.validation"
                [elementClass]="'form-group-label-i-l'">
                <input
                    [type]="showPin ? (deviceService.isiOS ? 'text' : 'tel') : 'password'"
                    name="pin"
                    lhNumberOnly
                    pattern="[0-9]*"
                    formControlName="pin"
                    inputmode="numeric"
                    class="form-control-i-l form-control-pw w-100"
                    autocomplete="current-password"
                    (keydown.enter)="login($event)" />
                <vn-icon name="theme-locked-i" extraClass="ui-icon vn-login__icon-left" />
                @if (!showPin) {
                    <vn-icon
                        name="theme-hide-password"
                        extraClass="toggle-password-button psw-i-l ui-icon vn-login__icon-right"
                        class="placeholder-old-icon psw-i-l"
                        (click)="togglePin()" />
                } @else {
                    <vn-icon
                        name="theme-show-password"
                        extraClass="toggle-password-button psw-i-l ui-icon vn-login__icon-right"
                        class="placeholder-old-icon psw-i-l"
                        (click)="togglePin()" />
                }
            </lh-form-field>
            @if (v2) {
                @if (loginConfig.rememberMeEnabled || rememberMeConfig.isEnabled) {
                    <lh-remember-me name="rememberme" formControlName="rememberme" />
                }
            } @else {
                <div class="d-flex align-items-center justify-content-between">
                    @if (loginConfig.rememberMeEnabled || rememberMeConfig.isEnabled) {
                        <lh-remember-me name="rememberme" formControlName="rememberme" />
                    }
                    <div class="pc-txt txt-s m-0" [vnDynamicHtml]="text"></div>
                </div>
            }
            <!--TODO: Remove the element when empty-->
            <lh-form-field>
                <vn-re-captcha formControlName="captcharesponse" name="reCaptcha" area="Login" />
                @if (reCaptchaControl && reCaptchaControl.touched && reCaptchaControl.errors) {
                    <div class="custom-error m2-validation-messages">
                        <span class="m2-validation-message" [innerHtml]="reCaptchaControl.errors?.verification.message || ''"></span>
                    </div>
                }
            </lh-form-field>
            <div class="form-element d-flex flex-wrap connect-card-login-buttons">
                @if (loginConfig.connectCardVersion === 2) {
                    <button
                        type="button"
                        ds-button
                        kind="secondary"
                        variant="outline"
                        size="large"
                        [class]="cssClass"
                        vnTrackingEvent="Event.Functionality.Login"
                        [vnTrackingData]="{
                            'page.referringAction': 'Login_ConnectCard_UseCredentialsButtonClicked',
                            'page.siteSection': 'Authentication',
                        }"
                        (click)="onBackClick()">
                        {{ content.form.usecredentialsbutton?.label }}
                    </button>
                }
                <button
                    ds-button
                    kind="primary"
                    variant="filled"
                    size="large"
                    class="ds-button-truncate"
                    [ngClass]="cssClass"
                    [disabled]="formGroup.disabled || isFormInvalid"
                    vnTrackingEvent="Event.Functionality.Login"
                    [vnTrackingData]="{
                        'page.referringAction': 'Login_ConnectCard_LoginButtonClicked',
                        'page.siteSection': 'Authentication',
                    }"
                    (click)="login($event)">
                    <i class="glyphicon" [class.glyphicon-time]="formGroup.disabled" [class.glyphicon-ok]="!formGroup.disabled"></i>
                    {{ loginButtonText }}
                </button>
            </div>
            @if (v2) {
                <div class="text-center pc-txt txt-s m-0" [vnDynamicHtml]="text"></div>
            }
        </section>
    </fieldset>
</form>
